<template>
  <div id="contenedor-contrato-plazo">
    <v-row no-gutters class="mb-1 caption">
      <v-col cols="auto">
        <span class="font-weight-bold">
          {{ getPlazo }}
        </span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <span class="font-weight-medium">
          {{ getFechaInicioFormated }} - {{ getFechaTerminoFormated }}
          <span v-if="mostrarEjercicio">/{{ getEjercicio }}</span>
        </span>
      </v-col>
    </v-row>
    <v-progress-linear :value="getProgreso" height="5" rounded color="success"></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: 'ContratoPlazo',
  props: {
    fechaInicio: {
      type: String,
      required: true,
    },
    fechaTermino: {
      type: String,
      required: true,
    },
    mostrarEjercicio: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    getDiferenciasDias(fechaInicio, fechaTermino) {
      if (fechaInicio > fechaTermino) return 0;

      const diferenciaMilisegundos = fechaTermino - fechaInicio;

      return diferenciaMilisegundos / (1000 * 60 * 60 * 24);
    },
  },
  computed: {
    getEjercicio() {
      const fechaTermino = new Date(`${this.fechaTermino}T00:00:00`);

      return fechaTermino.toLocaleString('es-ES', { year: '2-digit' });
    },
    getFechaInicioFormated() {
      const fechaInicio = new Date(`${this.fechaInicio}T00:00:00`);
      return `${fechaInicio.getDate().toString().padStart(2, '0')} ${fechaInicio.toLocaleString('es-ES', { month: 'short' })}`;
    },
    getFechaTerminoFormated() {
      const fechaTermino = new Date(`${this.fechaTermino}T00:00:00`);
      return `${fechaTermino.getDate().toString().padStart(2, '0')} ${fechaTermino.toLocaleString('es-ES', { month: 'short' })}`;
    },
    getPlazo() {
      return this.getDiferenciasDias(new Date(`${this.fechaInicio}T00:00:00`),
        new Date(`${this.fechaTermino}T00:00:00`)) || 0;
    },
    getProgreso() {
      const hoy = new Date();
      const diferencia = this.getDiferenciasDias(new Date(`${this.fechaInicio}T00:00:00`), hoy);

      return Math.round((diferencia / this.getPlazo) * 100);
    },
  },
};
</script>

<style lang="scss">

</style>
